import { Button, Flex, Text } from "@mantine/core";
import { IconFaceIdError } from "@tabler/icons-react";
import React from "react";

// Define the props for our fallback component
interface ErrorFallbackProps {
  error?: Error | null; // The error is optional
}

const ErrorFallback: React.FC<ErrorFallbackProps> = ({ error }) => {
  const refreshPage = () => {
    window.location.reload();
  };

  return (
    <Flex
      direction="column"
      align="center"
      justify="center"
      style={{ textAlign: "center", padding: "20px" }}
    >
      <IconFaceIdError size={120} color="black" />
      <Text fw={500} size="xl">
        Something went wrong.
      </Text>
      <Text size="md" mb={20}>
        We're bribing the server with biscuits 
      </Text>
      {/* Optionally display error details during development */}
      {process.env.NODE_ENV === "development" && error && (
        <pre style={{ whiteSpace: "pre-wrap", color: "red", maxWidth: "80%" }}>
          {error.message}
        </pre>
      )}
      <Button color="black" onClick={refreshPage}>
        Try again shortly.
      </Button>
    </Flex>
  );
};

export default ErrorFallback;
